import React from "react";
import { useHistory } from "react-router-dom";
import numeral from "numeral";

import HeaderContainer from "../../components/UI/‌Header/HeaderContainer";
import { handleLoading } from "../../store/actions/loadingAction";
import { useSelector } from "react-redux";
import { convertCurrency } from "../../store/actions/dollarPricesAction";
import useSWR from "swr";
import { Error, fetcher, Loading } from "../../components/UI/TableView/ShowPaginationData";
const smalltalk = require("smalltalk");

function SelectPackageScreen() {
  const { data: balances, isLoading, error } = useSWR('/balances', fetcher)
  const history = useHistory();

  // Balances.sort((a, b) => a.value - b.value);

  const onSelectPackage = async (data) => {
    try {
      handleLoading();
      history.push(
        `${window.location.pathname}/completeBalance?balance=${data._id}`
      );
      handleLoading();
    } catch (e) {
      handleLoading();
      smalltalk.alert("Error", e.message);
    }
  };

  if (isLoading) return <Loading />
  if (error) return <Error />

  return (
    <div className='flex flex-col items-center w-full '>
      {/* <HeaderContainer label={""} /> */}
      <div className='flex flex-row flex-wrap items-center justify-center w-full p-5'>
        {balances &&
          balances.map((dt) => {
            return (
              <div
                key={dt._id}
                onClick={onSelectPackage.bind(this, dt)}
                className={`flex cursor-pointer flex-col justify-between  m-2 bg-white border h-80 w-60 hover:opacity-80 `}>
                <div className='flex flex-col items-center justify-center w-full p-2 h-3/4'>
                  <h1 className='text-2xl font-medium opacity-80'>{dt.name}</h1>

                </div>
                <div
                  className={`flex items-center justify-end w-full p-5  h-1/5 ${"bg-mainAqwaBlue"}`}>
                  <h1 className='text-2xl text-white'>
                    {convertCurrency(dt.value, 'IQD', true)}
                  </h1>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default SelectPackageScreen;
